<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <material-card
            color="general"
            title="User Login Data"
            text="List of Username"
          >
            <v-spacer/>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              label="Search"
              placeholder="Search by Username"
              clearable
              single-line
              hide-details/>
            <v-dialog
              v-model="dialog"
              persistent
              max-width="720px">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="allowForceReset"
                  color="general"
                  dark
                  class="mb-2"
                  v-on="on">New
                </v-btn>
              </template>
              <v-form
                id="form-vue"
                ref="form"
                v-model="valid"
                :lazy-validation="lazy"
              >
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            :disabled="disableEdit"
                            v-model="editedItem.username"
                            :rules="[rules.required,rules.max50chars]"
                            hint="You cannot change this after create! (case-insensitive)"
                            label="User Login *"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.employee.firstName"
                            :rules="[rules.required,rules.max50chars]"
                            label="Employee Name*"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.employee.email"
                            :rules="[rules.email]"
                            label="Email"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.employee.phoneNo"
                            :rules="[rules.number]"
                            label="Phone No"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.employee.target"
                            :rules="[rules.number]"
                            label="Target (Rp)"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.employee.targetVisit"
                            :rules="[rules.number]"
                            label="Target Visit"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-select
                            v-model="editedItem.roleId"
                            :rules="[rules.required]"
                            :items="roles"
                            menu-props="auto"
                            label="Role"
                            item-text="name"
                            item-value="id"
                            placeholder="Select..."
                            filled/>

                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-checkbox
                            v-model="editedItem.enabled"
                            label="Enable"/>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer/>
                    <v-btn
                      color="red darken-1"
                      flat
                      @click="close">Cancel
                    </v-btn>
                    <v-btn
                      :disabled="!valid"
                      color="green darken-1"
                      flat
                      @click="save">Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>

            <v-dialog
              v-model="dialogReset"
              max-width="300px">
              <v-form
                id="form-resetpass"
                ref="form2"
                v-model="validResetPass"
                :lazy-validation="lazyValidation"
              >
                <v-card>
                  <v-card-text>
                    Are you sure want to RESET PASSWORD to this account?
                    "{{ resetPassForm.username }}"
                  </v-card-text>
                  <v-card-text>

                    <v-text-field
                      v-model="resetPassForm.password"
                      :rules="[rules.required,rules.max50chars]"
                      :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                      :type="showPassword ? 'text' : 'password'"
                      label="Reset Password Into"
                      single-line
                      counter
                      autofocus
                      required
                      @click:append="showPassword = !showPassword"
                    />

                    <v-text-field
                      v-model="resetPassForm.confirmPassword"
                      :rules="[rules.required,rules.max50chars,passwordConfirmationRule]"
                      :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                      :type="showPassword ? 'text' : 'password'"
                      label="Confirm Password"
                      single-line
                      counter
                      autofocus
                      required
                      @click:append="showPassword = !showPassword"
                    />

                  </v-card-text>
                  <v-card-actions>
                    <v-spacer/>
                    <v-btn
                      color="red darken-1"
                      text
                      @click="dialogReset = false"
                    >
                      Cancel
                    </v-btn>

                    <v-btn
                      :disabled="!validResetPass"
                      color="green darken-1"
                      text
                      @click="forceReset"
                    >
                      Ok
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>

            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="DataList"
              :rows-per-page-items="rowsAmount"
              :search="search"
              dense
              loading-text="Loading... Please wait"
              class="elevation-1"
            >
              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <td class="justify-center ">
                  <v-icon
                    medium
                    class="mr-2"
                    @click="editItem(props.item)">edit
                  </v-icon>
                  <v-icon
                    v-if="allowForceReset"
                    medium
                    @click="() => {dialogReset=true; resetPassForm=props.item}">mdi-lock-reset
                  </v-icon>
                </td>
                <td>{{ props.item.username }}</td>
                <td class="price-format">{{ toPriceFormat(props.item.employee.target) }}</td>
                <td>{{ props.item.employee.targetVisit }}</td>
                <td>{{ props.item.employee.firstName }}</td>
                <td>{{ props.item.role.name }}</td>
                <td>{{ props.item.employee.phoneNo }}</td>
                <td>{{ props.item.employee.email }}</td>
                <td>{{ props.item.enabled }}</td>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close
              </v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import displayFormatterMixins from '../../mixins/displayFormatterMixins'

  export default {
    mixins: [displayFormatterMixins],
    data: () => ({
      snack: false,
      valid: false,
      validResetPass: false,
      lazy: false,
      lazyValidation: false,
      showPassword: false,
      disableEdit: false,
      snackColor: '',
      snackText: '',
      resetPassForm: {
        username: '',
        password: '',
        confirmPassword: ''
      },
      resetPassFormDefault: {
        username: '',
        password: '',
        confirmPassword: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        number: value => !isNaN(value) || 'Must be numeric',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        }
        // newAndConfirmPassSame: value => value === this.resetPassForm.password || 'Reset & Confirm Password are not same'
      },
      pagination: {},
      DataList: [],
      totalRows: 0,
      checkboxEnabled: true,
      rowsAmount: [5, 20, 50, 100],
      dialog: false,
      dialogReset: false,
      resetRecord: {},
      loading: true,
      search: '',
      headers: [
        { text: '--Actions--', value: 'actions', sortable: false },
        { text: 'Username', value: 'username' },
        { text: 'Target (IDR)', value: 'employee.target', align: 'right' },
        { text: 'Target Visit', value: 'employee.targetVisit' },
        { text: 'Full Name', value: 'employee.firstName' },
        { text: 'Role', value: 'role' },
        { text: 'Phone No', value: 'employee.phoneNo' },
        { text: 'Email', value: 'employee.email' },
        { text: 'Enabled', value: 'isEnabled' }
      ],
      roles: [],
      editedIndex: -1,
      editedItem: {
        id: null,
        username: '',
        password: '',
        roleId: '',
        employee: {
          firstName: '',
          email: '',
          phoneNo: '',
          target: 0,
          targetVisit: 0
        },
        enabled: true,
      },
      defaultItem: {
        id: null,
        username: '',
        password: '',
        roleId: '',
        employee: {
          firstName: '',
          email: '',
          phoneNo: '',
          target: 0,
          targetVisit: 0
        },
        enabled: true
      }
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      allowForceReset () {
        return this.$store.getters['hasPermission']('MA_FORCE_RESET_PASS')
      },
      passwordConfirmationRule () {
        return (this.resetPassForm.password === this.resetPassForm.confirmPassword) || 'Password & Confirm Password must match'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    // called when page is created before dom
    created () {
      this.getDatatable()
      this.getRoles()
      this.resetPassForm.password = ''
    },

    methods: {
      async getRoles () {
        try {
          let response = await this.$http.get('/api/role?ps=15&so=name')
          this.roles = response.data.content
        } catch (error) {
          console.log(error)
        }
      },
      async getDatatable () {
        try {
          let response = await this.$http.get('/api/userlogin?ps=15&so=name')
          this.DataList = response.data.content
          this.totalRows = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },

      // object.assign fills in the empty object with the properties of item
      editItem (item, dbox = true) {
        this.editedIndex = this.DataList.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = dbox
        this.disableEdit = true
      },

      callTableAction (item, endpoint, method) {
        let tableItem = this.editedItem
        this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
          .then((response) => this.saveInline())
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
      },
      async forceReset () {
        if (!this.$refs.form2.validate()) {
          console.log('validation fail direct')
          return false
        }
        let endpoint = `api/userlogin/forcereset`
        let method = 'patch'
        let tableItem = this.resetPassForm
        try {
          let resp = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
          console.log(resp)
          if (resp.data.message === 'SUCCESS') {
            this.snack = true
            this.snackColor = 'success'
            this.snackText = 'Success Reset Account!'
          } else {
            this.snack = true
            this.color = 'error'
            this.snackText = resp.data.details
          }
        } catch (error) {
          console.log(error)
          this.snackbar = true
          this.color = 'error'
          this.snackText = 'Reset Password Fail!'
        }
        this.close()
      },

      close () {
        this.dialog = false
        this.dialogReset = false
        this.disableEdit = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.resetPassForm = Object.assign({}, this.resetPassFormDefault)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        this.disableEdit = false
        if (!this.$refs.form.validate()) {
          console.log('validation fail direct')
        }
        if (this.$refs.form.validate()) {
          console.log('validation success')
        }
        if (this.editedIndex > -1) {
          let tableItem = this.editedItem
          let endpoint = `api/userlogin/${this.editedItem.id}`
          let method = 'patch'
          this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            .then((response) => {
              if (response.data.message) {
                this.errorInline(response.data.message, response.data.details)
              } else {
                this.getDatatable()
                this.saveInline()
              }
            })
            .catch(error => {
              console.log(error)
              this.cancelInline()
            })
        } else {
          let tableItem = this.editedItem
          // this.DataList.push(this.editedItem)
          let endpoint = `api/userlogin`
          let method = 'post'
          this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            .then((response) => {
              this.getDatatable()
              this.saveInline()
            })
            .catch(error => {
              console.log(error)
              let resp = error.response.data
              if (resp.message) {
                this.errorInline('Duplicate Entry', resp.message)
              } else {
                this.cancelInline()
              }
            })
        }
        this.close()
      },
      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      errorInline (hdr, det) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = `${hdr}: ${det}`
      },
      cancelInline () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      reset () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      },
      openInline () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      closeInline () {
        console.debug('Dialog closed')
      }
    }
  }
</script>

<style scoped>

  tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .05);
  }
</style>
